// extracted by mini-css-extract-plugin
export default {"footer-locale-picker":"mAZF70It--FooterLocalePicker_footer-locale-picker__oiOne","footerLocalePicker":"mAZF70It--FooterLocalePicker_footer-locale-picker__oiOne"};